import React from 'react';
import PropTypes from 'prop-types';

export default function Icon(props) {
  let { name, size, color, className, ...args } = props;
  function getComputedStyle(size, color) {
    return {
      width: `${size}px`,
      height: `${size}px`,
      backgroundColor: color,
    };
  }
  return (
    <i
      className={`km__c--icon km__c--icon-is-${name} ${className}`}
      style={getComputedStyle(size, color)}
      {...args}
    ></i>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
};
Icon.defaultProps = {
  size: '24',
  color: '#061938',
};
